<template>
  <div class="template-manage-page">
    <div class="filter-bar">
      <el-form :inline="true" :model="searchForm" class="filter-form" size="small">
        <el-form-item label="模板名称">
          <el-input
            v-model.trim="searchForm.templateName"
            placeholder="请输入模板名称"
            clearable
            maxlength="100"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        <el-form-item label="使用端">
          <el-select v-model="searchForm.useTerminal" placeholder="请选择" clearable>
            <el-option v-for="item in terminalOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型">
          <el-select v-model="searchForm.templateType" placeholder="请选择" clearable>
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.statusCode" placeholder="请选择" clearable>
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" v-loading="loading" border stripe size="small" class="template-table">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="useTerminal" label="使用端" width="110" align="center">
        <template slot-scope="{ row }">{{ terminalLabel(row.useTerminal) }}</template>
      </el-table-column>
      <el-table-column prop="templateType" label="模板类型" width="120" align="center">
        <template slot-scope="{ row }">{{ typeLabel(row.templateType) }}</template>
      </el-table-column>
      <el-table-column prop="templateName" label="模板名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="templateContent" label="模板内容" min-width="260" show-overflow-tooltip />
      <el-table-column prop="voiceEnabled" label="语音播报" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.voiceEnabled ? 'success' : 'info'" size="small">
            {{ row.voiceEnabled ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="blinkEnabled" label="字体闪动" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.blinkEnabled ? 'warning' : 'info'" size="small">
            {{ row.blinkEnabled ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="statusCode" label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.statusCode === 'ENABLED' ? 'success' : 'info'" size="small">
            {{ statusLabel(row.statusCode) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新日期" width="170" align="center" />
      <el-table-column label="操作" width="280" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="handleDetail(row)">详情</el-button>
          <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
          <el-button
            v-if="isMiniProgramBaiduTemplate(row)"
            type="text"
            size="small"
            @click="openPreferenceDialog(row)"
          >
            通知偏好
          </el-button>
          <el-button
            v-if="isMiniProgramBaiduTemplate(row)"
            type="text"
            size="small"
            @click="openBindingDialog"
          >
            绑定管理
          </el-button>
          <el-button type="text" size="small" @click="handleToggleStatus(row)">
            {{ row.statusCode === 'ENABLED' ? '禁用' : '启用' }}
          </el-button>
          <el-button type="text" size="small" class="danger-btn" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="760px" :close-on-click-modal="false" @close="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px" size="small">
        <el-row>
          <el-col :span="12">
            <el-form-item label="模板名称" prop="templateName">
              <el-input
                v-model.trim="form.templateName"
                maxlength="100"
                show-word-limit
                clearable
                :disabled="detailMode"
                placeholder="请输入模板名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用端" prop="useTerminal">
              <el-select v-model="form.useTerminal" placeholder="请选择" :disabled="detailMode" class="form-control">
                <el-option v-for="item in terminalOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="模板类型" prop="templateType">
              <el-select v-model="form.templateType" placeholder="请选择" :disabled="detailMode" class="form-control">
                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="statusCode">
              <el-select v-model="form.statusCode" :disabled="detailMode" class="form-control">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="语音播报">
              <el-switch v-model="form.voiceEnabled" :disabled="detailMode" active-text="启用" inactive-text="禁用" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="字体闪动">
              <el-radio-group v-model="form.blinkEnabled" :disabled="detailMode">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="背景颜色">
              <el-color-picker
                v-if="form.templateType === 'BAIDU_PUSH'"
                v-model="form.backgroundColor"
                show-alpha
                color-format="rgba"
                :disabled="detailMode"
              />
              <el-input v-else v-model.trim="form.backgroundColor" :disabled="detailMode" placeholder="white" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="字体颜色">
              <el-color-picker
                v-if="form.templateType === 'BAIDU_PUSH'"
                v-model="form.fontColor"
                show-alpha
                color-format="rgba"
                :disabled="detailMode"
              />
              <el-input v-else v-model.trim="form.fontColor" :disabled="detailMode" placeholder="red" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="字体大小">
              <el-select v-model="form.fontSize" :disabled="detailMode" class="form-control">
                <el-option label="14px" value="14px" />
                <el-option label="16px" value="16px" />
                <el-option label="18px" value="18px" />
                <el-option label="20px" value="20px" />
                <el-option label="24px" value="24px" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="模板内容" prop="templateContent">
              <el-input
                v-model="form.templateContent"
                type="textarea"
                :rows="6"
                maxlength="1000"
                show-word-limit
                resize="none"
                :disabled="detailMode"
                placeholder="请输入模板内容"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="isMiniProgramBaiduTemplate(form)">
          <el-row>
            <el-col :span="12">
              <el-form-item label="企微 AgentId">
                <el-input v-model.trim="form.channelConfig.wecomAgentId" :disabled="detailMode" placeholder="如 1000002" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订阅模板ID">
                <el-input v-model.trim="form.channelConfig.wechatTemplateId" :disabled="detailMode" placeholder="如 tmpl_xxx" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="跳转页面">
                <el-input v-model.trim="form.channelConfig.pagePath" :disabled="detailMode" placeholder="pages/baidu-marketing/index" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字段版本">
                <el-input v-model.trim="form.channelConfig.fieldMappingVersion" :disabled="detailMode" placeholder="v1" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="企微标题">
                <el-input v-model.trim="form.channelConfig.wecomTitle" :disabled="detailMode" placeholder="百度线索提醒" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企微摘要">
                <el-input v-model.trim="form.channelConfig.wecomSummary" :disabled="detailMode" placeholder="请尽快处理新线索" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ detailMode ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!detailMode" type="primary" :loading="saveLoading" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="通知偏好" :visible.sync="preferenceVisible" width="620px" :close-on-click-modal="false">
      <el-form :model="preferenceForm" label-width="120px" size="small">
        <el-form-item label="提示方式">
          <el-radio-group v-model="preferenceForm.alertMode">
            <el-radio-button label="BOTH">双通道提醒</el-radio-button>
            <el-radio-button label="SYSTEM">仅系统通知</el-radio-button>
            <el-radio-button label="DOM">仅DOM弹窗</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消息类型">
          <el-checkbox-group v-model="preferenceForm.messageTypes">
            <el-checkbox label="BAIDU_PUSH">百度推送</el-checkbox>
            <el-checkbox label="URGENT_ALERT">紧急告警</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="谁能接收通知">
          <utwl-common-select
            v-model="preferenceForm.receiverUserIds"
            url="/user/list"
            width="100%"
            multiple
            collapse-tags
            search-param="nickname"
            value-key="id"
            label-key="nickname"
            :page-size="10"
            :selected-options="preferenceForm.receiverUsers"
            :query-params="{ statusCode: 'ACTIVE' }"
            :label-formatter="formatReceiverUserLabel"
            placeholder="请选择接收通知的人员"
            error-message="加载用户列表失败"
            @selected-options-change="handleReceiverUserOptionsChange"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="preferenceVisible = false">取消</el-button>
        <el-button type="primary" :loading="preferenceSaving" @click="savePreference">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="绑定管理" :visible.sync="bindingVisible" width="760px" :close-on-click-modal="false">
      <el-table :data="bindingList" v-loading="bindingLoading" size="small" border>
        <el-table-column prop="nickname" label="接收人" min-width="120" align="center" />
        <el-table-column prop="phone" label="手机号" width="130" />
        <el-table-column label="绑定状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="bindingStatusTag(row).type" size="small">{{ bindingStatusTag(row).text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="企微" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="bindingChannelStatusTag('wecomStatus', row.wecomStatus).type" size="small">
              {{ bindingChannelStatusTag('wecomStatus', row.wecomStatus).text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="服务通知" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="bindingChannelStatusTag('wechatNoticeStatus', row.wechatNoticeStatus).type" size="small">
              {{ bindingChannelStatusTag('wechatNoticeStatus', row.wechatNoticeStatus).text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="createBindingQr(row)">生成绑定入口</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="bindingPreview.qrCodeDataUrl || bindingPreview.page || bindingPreview.entryErrorMessage" class="binding-preview">
        <div v-if="bindingPreview.qrCodeDataUrl" class="binding-preview__qrcode">
          <img :src="bindingPreview.qrCodeDataUrl" alt="binding-qrcode">
        </div>
        <div v-if="bindingPreview.page">绑定页面：{{ bindingPreview.page }}</div>
        <div v-else-if="bindingPreview.qrCodeDataUrl">绑定入口仅支持微信扫码打开小程序</div>
        <div v-if="bindingPreview.entryErrorMessage" class="binding-preview__warning">文本绑定入口生成失败：{{ bindingPreview.entryErrorMessage }}</div>
        <div>接收人：{{ bindingPreview.displayAccount }}</div>
        <div>有效期至：{{ bindingPreview.expiresAt }}</div>
      </div>
      <span slot="footer">
        <el-button @click="bindingVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/services/api';
import UtwlCommonSelect from '@/components/utwl-common-select.vue';
import { mergeReceiverUserSnapshots } from '@/utils/notificationPreferenceForm.mjs';
import { fetchLeadNotificationBindings, createLeadNotificationBindingQrCode } from '@/services/leadNotificationApi.mjs';
import { buildBindingStatusTag, isMiniProgramBaiduTemplate, normalizeChannelConfigForm } from '@/utils/leadNotificationTemplate.mjs';
import { buildBindingChannelStatusTag } from '@/utils/leadNotificationBindingDisplay.mjs';

const terminalOptions = [
  { label: 'PC端', value: 'DESKTOP' },
  { label: '小程序端', value: 'MINI_PROGRAM' }
];

const typeOptions = [
  { label: '推荐学员', value: 'REFERRAL_STUDENT' },
  { label: '推荐奖励', value: 'REFERRAL_REWARD' },
  { label: '返佣奖励', value: 'COMMISSION_REWARD' },
  { label: '提现到账', value: 'WITHDRAWAL_ARRIVED' },
  { label: '学员已报名', value: 'STUDENT_ENROLLED' },
  { label: '提现申请', value: 'WITHDRAWAL_APPLY' },
  { label: '实名认证', value: 'REAL_NAME_AUTH' },
  { label: '百度推送', value: 'BAIDU_PUSH' },
  { label: '通用提示', value: 'GENERAL_NOTICE' }
];

const statusOptions = [
  { label: '启用', value: 'ENABLED' },
  { label: '禁用', value: 'DISABLED' }
];

function makeForm() {
  return {
    templateName: '',
    useTerminal: 'MINI_PROGRAM',
    templateType: '',
    voiceEnabled: false,
    backgroundColor: 'white',
    fontColor: 'red',
    fontSize: '16px',
    blinkEnabled: true,
    statusCode: 'DISABLED',
    templateContent: '',
    channelConfig: normalizeChannelConfigForm()
  };
}

function makePreferenceForm(data = {}) {
  return {
    alertMode: data.alertMode || 'BOTH',
    messageTypes: Array.isArray(data.messageTypes) && data.messageTypes.length
      ? data.messageTypes
      : ['BAIDU_PUSH', 'URGENT_ALERT'],
    receiverUserIds: Array.isArray(data.receiverUserIds) ? data.receiverUserIds : [],
    receiverUsers: Array.isArray(data.receiverUsers) ? data.receiverUsers : []
  };
}

export default {
  name: 'TemplateManage',
  components: {
    UtwlCommonSelect
  },
  data() {
    const validateName = (rule, value, callback) => {
      const text = String(value || '').trim();
      if (!text) return callback(new Error('请输入模板名称'));
      if (!/^[\u4e00-\u9fa5A-Za-z0-9 _\-()（）]+$/.test(text)) {
        return callback(new Error('模板名称不能包含特殊字符'));
      }
      callback();
    };
    return {
      terminalOptions,
      typeOptions,
      statusOptions,
      loading: false,
      saveLoading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        templateName: '',
        useTerminal: '',
        templateType: '',
        statusCode: ''
      },
      dialogVisible: false,
      preferenceVisible: false,
      bindingVisible: false,
      preferenceSaving: false,
      bindingLoading: false,
      detailMode: false,
      editId: '',
      form: makeForm(),
      preferenceForm: makePreferenceForm(),
      bindingList: [],
      bindingPreview: {},
      rules: {
        templateName: [
          { required: true, validator: validateName, trigger: ['blur', 'change'] }
        ],
        useTerminal: [
          { required: true, message: '请选择使用端', trigger: 'change' }
        ],
        templateType: [
          { required: true, message: '请选择模板类型', trigger: 'change' }
        ],
        statusCode: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        templateContent: [
          { required: true, message: '请输入模板内容', trigger: 'blur' },
          { max: 1000, message: '模板内容不能超过1000字', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  computed: {
    dialogTitle() {
      if (this.detailMode) return '模板详情';
      return this.editId ? '编辑模板' : '添加模板';
    }
  },
  mounted() {
    this.loadList();
  },
  methods: {
    isMiniProgramBaiduTemplate,
    terminalLabel(value) {
      const found = this.terminalOptions.find(item => item.value === value);
      return found ? found.label : '-';
    },
    typeLabel(value) {
      const found = this.typeOptions.find(item => item.value === value);
      return found ? found.label : '-';
    },
    statusLabel(value) {
      const found = this.statusOptions.find(item => item.value === value);
      return found ? found.label : '-';
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    async loadList() {
      this.loading = true;
      try {
        const res = await api.post('/system/message-template/list', {
          ...this.searchForm,
          page: this.currentPage,
          pageSize: this.pageSize
        });
        const payload = res.data && res.data.data ? res.data.data : {};
        this.tableData = Array.isArray(payload.list) ? payload.list : [];
        this.total = Number(payload.total || 0);
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.message;
        this.$message.error(message || '加载模板列表失败');
        this.tableData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadList();
    },
    handleReset() {
      this.searchForm = {
        templateName: '',
        useTerminal: '',
        templateType: '',
        statusCode: ''
      };
      this.currentPage = 1;
      this.loadList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadList();
    },
    fillForm(row) {
      this.form = {
        templateName: row.templateName || '',
        useTerminal: row.useTerminal || 'MINI_PROGRAM',
        templateType: row.templateType || '',
        voiceEnabled: !!row.voiceEnabled,
        backgroundColor: row.backgroundColor || 'white',
        fontColor: row.fontColor || 'red',
        fontSize: row.fontSize || '16px',
        blinkEnabled: row.blinkEnabled !== false,
        statusCode: row.statusCode || 'DISABLED',
        templateContent: row.templateContent || '',
        channelConfig: normalizeChannelConfigForm(row.channelConfig)
      };
    },
    handleAdd() {
      this.detailMode = false;
      this.editId = '';
      this.form = {
        ...makeForm(),
        templateType: 'BAIDU_PUSH',
        templateName: '百度营销推广',
        templateContent: '百度营销推广有新数据，请立即处理！',
        voiceEnabled: true,
        statusCode: 'ENABLED'
      };
      this.dialogVisible = true;
    },
    handleDetail(row) {
      this.detailMode = true;
      this.editId = row.id;
      this.fillForm(row);
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.detailMode = false;
      this.editId = row.id;
      this.fillForm(row);
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = makeForm();
      this.editId = '';
      this.detailMode = false;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    handleSave() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.saveLoading = true;
        try {
          const url = this.editId
            ? `/system/message-template/${this.editId}/update`
            : '/system/message-template/add';
          await api.post(url, { ...this.form });
          this.$message.success(this.editId ? '更新成功' : '新增成功');
          this.dialogVisible = false;
          this.loadList();
        } catch (e) {
          const message = e.response && e.response.data && e.response.data.message;
          this.$message.error(message || '保存失败');
        } finally {
          this.saveLoading = false;
        }
      });
    },
    async handleToggleStatus(row) {
      const next = row.statusCode === 'ENABLED' ? 'DISABLED' : 'ENABLED';
      await api.post(`/system/message-template/${row.id}/status`, { statusCode: next });
      this.$message.success(next === 'ENABLED' ? '已启用' : '已禁用');
      this.loadList();
    },
    handleDelete(row) {
      this.$confirm('确定删除该模板吗？', '提示', { type: 'warning' })
        .then(async () => {
          await api.post(`/system/message-template/${row.id}/remove`);
          this.$message.success('删除成功');
          if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1;
          this.loadList();
        })
        .catch(() => {});
    },
    bindingStatusTag(row) {
      return buildBindingStatusTag(row);
    },
    bindingChannelStatusTag(field, value) {
      return buildBindingChannelStatusTag(field, value);
    },
    formatReceiverUserLabel(option = {}) {
      const nickname = String(option.nickname || option.username || option.name || '').trim();
      const phone = String(option.phone || option.phoneNumber || '').trim();
      if (nickname && phone) return `${nickname}（${phone}）`;
      return nickname || phone || String(option.id || option.userId || '').trim();
    },
    handleReceiverUserOptionsChange(options = []) {
      this.preferenceForm.receiverUsers = mergeReceiverUserSnapshots(
        this.preferenceForm.receiverUsers,
        options,
        this.preferenceForm.receiverUserIds
      );
    },
    async openPreferenceDialog(row = {}) {
      this.preferenceVisible = true;
      try {
        const res = await api.post('/system/message-template/notification-preference/query', {
          templateType: row.templateType || 'BAIDU_PUSH',
          useTerminal: row.useTerminal || 'MINI_PROGRAM'
        });
        const data = res.data && res.data.data ? res.data.data : {};
        this.preferenceForm = makePreferenceForm(data);
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.message;
        this.$message.error(message || '通知偏好加载失败');
      }
    },
    async savePreference() {
      this.preferenceSaving = true;
      try {
        await api.post('/system/message-template/notification-preference/save', {
          ...this.preferenceForm,
          templateType: 'BAIDU_PUSH',
          useTerminal: 'MINI_PROGRAM'
        });
        this.$message.success('通知偏好已保存');
        this.preferenceVisible = false;
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.message;
        this.$message.error(message || '保存失败');
      } finally {
        this.preferenceSaving = false;
      }
    },
    async openBindingDialog() {
      this.bindingVisible = true;
      this.bindingPreview = {};
      this.bindingLoading = true;
      try {
        this.bindingList = await fetchLeadNotificationBindings();
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.message;
        this.$message.error(message || '加载绑定列表失败');
      } finally {
        this.bindingLoading = false;
      }
    },
    async createBindingQr(row) {
      try {
        this.bindingPreview = await createLeadNotificationBindingQrCode(row.userId);
        this.$message.success('已生成绑定入口');
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.message;
        this.$message.error(message || '生成绑定入口失败');
      }
    }
  }
};
</script>

<style scoped>
.template-manage-page {
  padding: 24px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.filter-bar {
  margin-bottom: 12px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 0 8px;
}

.template-table {
  flex: 1;
  min-height: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
}

.form-control {
  width: 100%;
}

.danger-btn {
  color: #f56c6c;
}

.binding-preview {
  margin-top: 16px;
  padding: 12px 14px;
  background: #f7f9fc;
  border: 1px solid #e6ecf5;
  border-radius: 8px;
  line-height: 1.8;
  color: #4b5563;
}

.binding-preview__warning {
  color: #e6a23c;
}

.binding-preview__qrcode {
  margin-bottom: 12px;
}

.binding-preview__qrcode img {
  display: block;
  width: 220px;
  height: 220px;
  max-width: 100%;
  border: 1px solid #e6ecf5;
  border-radius: 8px;
  background: #fff;
}
</style>
